import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getOfficeDetails } from 'modules/settings/api';

export const useQueryOfficeDetails = (officeId: string | null) => {
  const {
    data: officeDetailsData,
    isLoading: officeDetailsLoading,
    isError: officeDetailsError,
  } = useQuery([QUERY_KEYS.RENTALS_OFFICE_DETAILS], () => getOfficeDetails(officeId), {
    enabled: !!officeId,
    cacheTime: 0,
  });

  return { officeDetailsData, officeDetailsLoading, officeDetailsError };
};
